var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotIncluded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8178_20634)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8178_20634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3334 8.00033C15.3334 12.047 12.0467 15.3337 8.00008 15.3337C3.95341 15.3337 0.666748 12.047 0.666748 8.00033C0.666748 3.95366 3.95341 0.666992 8.00008 0.666992C12.0467 0.666992 15.3334 3.95366 15.3334 8.00033ZM5.33341 7.33366C4.96675 7.33366 4.66675 7.63366 4.66675 8.00033C4.66675 8.36699 4.96675 8.66699 5.33341 8.66699H10.6667C11.0334 8.66699 11.3334 8.36699 11.3334 8.00033C11.3334 7.63366 11.0334 7.33366 10.6667 7.33366H5.33341Z",
    fill: "#36383E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8178_20634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8178_20634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotIncluded);
export default __webpack_public_path__ + "static/media/icon-not-included.628a8c8b69637241345426a03a9bd5e5.svg";
export { ForwardRef as ReactComponent };